export const roundToPrecision = (value: number, precision: number) => {
  const pow = Math.pow(10, precision);
  return Math.round((value + Number.EPSILON) * pow) / pow;
};
